import { Spinner } from '@/components/Spinner';
import { usePointSlabDetail } from '@/features/points-management/points-configuration/hooks/usePointDetails';
import { PointAgentTab } from '@/features/points-management/points-configuration/pointConfiguration.constants';
import ManageSlabs from './ManageSlabs';

const ManageSlabsContainer = ({
  pointCategoryId,
  categoryName,
  activeTab,
  pointSlabId,
}: {
  pointCategoryId: string;
  categoryName?: string;
  activeTab: PointAgentTab;
  pointSlabId?: string;
}) => {
  const { slab, isLoading } = usePointSlabDetail(pointSlabId);

  if (isLoading) return <Spinner />;

  return (
    <ManageSlabs pointCategoryId={pointCategoryId} categoryName={categoryName} activeTab={activeTab} slab={slab} />
  );
};

export default ManageSlabsContainer;
